'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMerchants = undefined;

var _serviceHelpers = require('./serviceHelpers');

var getMerchants = exports.getMerchants = function getMerchants(accessToken, env) {
  return (0, _serviceHelpers.callFetch)('merchantConfigUrl', 'GET', 'v0/merchants?verbose=false', null, accessToken, env).then(function (merchants) {
    return merchants.map(function (_ref) {
      var merchantId = _ref.merchantId,
          displayName = _ref.displayName,
          claimCategories = _ref.claimCategories,
          _links = _ref._links;
      return {
        merchantId: merchantId,
        displayName: displayName || merchantId,
        claimCategories: claimCategories,
        _links: _links
      };
    });
  });
};